import React, { useState } from "react";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
} from "@mui/material";
import { cellSX, layoutCSS } from "../component/common/commonStyle";

const ManageKYC = () => {
  const [formData, setFormData] = useState({
    aadharNumber: "",
    panNumber: "",
    frontAadharFile: null,
    backAadharFile: null,
    panFile: null,
  });

  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePreview = (file) => {
    if (file) {
      const previewURL =
        typeof file === "object" ? URL.createObjectURL(file) : file;
      setPreviewFile(previewURL);
      setIsPreviewOpen(true);
    }
  };

  const closePreview = () => {
    if (previewFile) {
      URL.revokeObjectURL(previewFile);
    }
    setIsPreviewOpen(false);
    setPreviewFile(null);
  };

  const [tableData, setTableData] = useState([]);
  const [warning, setWarning] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !formData.aadharNumber ||
      !formData.panNumber ||
      !formData.frontAadharFile ||
      !formData.backAadharFile ||
      !formData.panFile
    ) {
      setWarning("All fields are mandatory. Please fill out every field.");
      return;
    }

    setTableData([...tableData, formData]);

    setFormData({
      aadharNumber: "",
      panNumber: "",
      frontAadharFile: null,
      backAadharFile: null,
      panFile: null,
    });
    setWarning("");
  };

  return (
    <Box sx={layoutCSS}>
      <Typography variant="h6" gutterBottom sx={{ fontSize: "0.9rem",fontWeight:'bold' }}>
        Manage KYC
      </Typography>

      <Alert severity="error" sx={{ mb: 2, fontSize: "0.75rem" }}>
        Note: You have only one chance to upload KYC documents, so please upload
        documents carefully.
      </Alert>

      {warning && (
        <Alert severity="warning" sx={{ mb: 2, fontSize: "0.75rem" }}>
          {warning}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Aadhar Card Number"
              name="aadharNumber"
              value={formData.aadharNumber}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{
                "& .MuiInputBase-input": { fontSize: "0.75rem" },
                "& .MuiInputLabel-root": { fontSize: "0.75rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="showreportcount Card Number"
              name="panNumber"
              value={formData.panNumber}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{
                "& .MuiInputBase-input": { fontSize: "0.75rem" },
                "& .MuiInputLabel-root": { fontSize: "0.75rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="file"
              name="frontAadharFile"
              onChange={handleFileChange}
              InputLabelProps={{ shrink: true }}
              label="Upload Front Aadhar Card"
              size="small"
              sx={{
                "& .MuiInputBase-input": { fontSize: "0.75rem" },
                "& .MuiInputLabel-root": { fontSize: "0.75rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="file"
              name="backAadharFile"
              onChange={handleFileChange}
              InputLabelProps={{ shrink: true }}
              label="Upload Back Aadhar Card"
              size="small"
              sx={{
                "& .MuiInputBase-input": { fontSize: "0.75rem" },
                "& .MuiInputLabel-root": { fontSize: "0.75rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="file"
              name="panFile"
              onChange={handleFileChange}
              InputLabelProps={{ shrink: true }}
              label="Upload showreportcount Card"
              variant="outlined"
              size="small"
              sx={{
                "& .MuiInputBase-input": { fontSize: "0.75rem" },
                "& .MuiInputLabel-root": { fontSize: "0.75rem" },
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button type="submit" variant="contained" color="primary" sx={{ fontSize: "0.75rem", textTransform: "none" }}>
              Upload Documents
            </Button>
          </Grid>
        </Grid>
      </form>

      {isPreviewOpen && previewFile && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              margin: "50px auto",
              width: "80%",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              onClick={closePreview}
              style={{ marginTop: "20px" }}
            >
              Close Preview
            </Button>
          </div>
        </div>
      )}

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead
            sx={{
              bgcolor: '#0288d1',
              "& th": {
                // fontWeight: "bold",
                color: "white",
                fontSize: '0.75rem',
                // textTransform: "uppercase",
                borderBottom: '0.5px solid #B0B0B0',
              },
            }}
          >
            <TableRow >
              <TableCell>Aadhar Number</TableCell>
              <TableCell>Front Aadhar</TableCell>
              <TableCell>Back Aadhar</TableCell>
              <TableCell>showreportcount Number</TableCell>
              <TableCell>showreportcount File</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length > 0 ? (
              tableData.map((data, index) => (
                <TableRow key={index}>
                  <TableCell>{data.aadharNumber}</TableCell>
                  <TableCell>
                    <PreviewIcon
                      onClick={() => handlePreview(data.frontAadharFile)}
                      style={{ cursor: "pointer" }}
                    />
                  </TableCell>
                  <TableCell>
                    <PreviewIcon
                      onClick={() => handlePreview(data.backAadharFile)}
                      style={{ cursor: "pointer" }}
                    />
                  </TableCell>
                  <TableCell>{data.panNumber}</TableCell>
                  <TableCell>
                    <PreviewIcon
                      onClick={() => handlePreview(data.panFile)}
                      style={{ cursor: "pointer" }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell sx={cellSX} colSpan={5} align="center">
                  Sorry, No Record Found!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ManageKYC;
